<script>
import { mapState } from 'vuex'
import moment from 'moment'
import mixins from '@services/notification/notifications-mixin'

export default {
  mixins: [mixins],
  computed: {
    ...mapState({
      messages: state => state.userNotifications.userNotifications,
    }),
    unreadCount() {
      return this.messages.filter(item => !item.read).length
    },
    iconColor() {
      return this.unreadCount > 0 ? 'blue' : 'gray'
    },
  },
  methods: {
    markRead(message) {
      this.$store.dispatch('userNotifications/markRead', message.id)
      this.$store.commit('notifications/DELETE', message.id)
    },
    markReadAll() {
      this.$store.dispatch('userNotifications/markReadAll')
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    clickHandler(notification) {
      this.markRead(notification)
      this.doAction(notification)
    },
  },
}
</script>

<template>
  <v-menu
    slot="activator"
    top
    left
    origin="right top"
    transition="scale-transition"
  >
    <v-btn
      slot="activator"
      icon
    >
      <v-badge>
        <v-icon
          :color="iconColor"
          medium
        >
          circle_notifications
        </v-icon>
        <template
          v-slot:badge
          v-if="unreadCount > 0">
          <span class="circle">{{ unreadCount }}</span>
        </template>
      </v-badge>
    </v-btn>
    <v-card>
      <v-toolbar
        color="primary"
        dark>
        <v-toolbar-title>Notifications</v-toolbar-title>
        <v-spacer/>
        <v-btn 
          icon 
          @click="markReadAll">
          <v-icon>done_all</v-icon>
        </v-btn>
        <v-btn
          icon
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list three-line>
        <template v-if="!messages || messages.length === 0">
          <v-list-tile>
            {{ $t('titles__no_notifications') }}
          </v-list-tile>
        </template>
        <template v-for="(message, index) in messages">
          <v-list-tile
            :key="message.id"
            :class="{notRead: !message.read }"
            avatar
            ripple
            @click="clickHandler(message)"
          >
            <v-list-tile-avatar style="margin-top: 0">
              <v-icon v-if="message.read">notifications_none</v-icon>
              <v-icon v-else>notifications_active</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t(message.type) }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ 'Plug Id: ' + message.extraParameters.plugId }}</v-list-tile-sub-title>
              <v-list-tile-sub-title :class="[!message.read ? 'notRead text--primary' : 'text--primary' ]">{{ message.message }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text> {{ formatDate(message.created) }}</v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider
            v-if="index + 1 < messages.length"
            :key="`divider_${message.id}`"
          />
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<style lang="scss" scoped>
@import '@design';

.item {
  margin: 8px;
  cursor: pointer;
}

.notRead {
  font-weight: bolder;
}

.active {
  pointer-events: none;
  background-color: #dfdfdf;
}

.circle {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-top: -3px;
  margin-left: -7px;
  font-size: 10px;
  line-height: 15px;
  color: white;
  text-align: center;
  vertical-align: top !important;
  background-color: orangered;
  border-radius: 50%;
}

.notification {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 14px;
}

.date {
  line-height: 26px;
  color: #1976d2;
}
</style>
